import { Body, Flex, Heading, Icon } from '@hover/blueprint';
import { iChevronRight } from '@hover/icons';
import React from 'react';

import { ProductIcon } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/ProductIcon';
import { getMaterialColor } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/utils';
import type { MaterialGroup } from 'src/modules/designStudio/helpers/productSelection/types';

export const ProductListItem = ({
  material,
  onClick,
}: {
  material: MaterialGroup;
  onClick: () => void;
}) => {
  const variation = material.variation!;
  const colorName = getMaterialColor(material);
  return (
    <Flex
      alignItems="center"
      as="button"
      backgroundColor="#ffffff"
      borderStyle="none"
      direction="row"
      gap={600}
      onClick={onClick}
    >
      <ProductIcon
        as="div"
        color={material.appearance.color ?? '#ffffff'}
        flex={3}
        isSelected={false}
        maxWidth="150px"
        thumbnail={variation.thumbnailURL ?? ''}
        width="100%"
      />
      <Flex direction="column" flex={3} gap={50} justifyContent="space-around">
        <Heading my={0} size={200}>
          {variation.product.provider.name}
        </Heading>
        <Body my={0}>{colorName}</Body>
      </Flex>
      <Icon
        flexShrink={0}
        icon={iChevronRight}
        marginLeft="auto"
        size="large"
      />
    </Flex>
  );
};
